import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import courseRegisterIndividualReadAction from './courseRegisterIndividualRead.action.json' with { type: 'json' }

const courseRegisterIndividualReadDefinition = defineReadAutoAction(courseRegisterIndividualReadAction, 'courseRegisterIndividual')

export default courseRegisterIndividualReadDefinition
